<template>
  <div class="doctor-wrapper">
    <div class="list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
    <div class="doctor-list" v-else-if="dataDone && doctorList.length > 0">
      <div class="doctor-item" @click="toDetail(item)" v-for="item in doctorList">
        <div class="doctor-card">
          <div class="doc-info">
            <div class="info">
              <div class="avatar"><img :src="item.avatar" alt=""></div>
              <div class="info-text">
                <div class="name">{{item.username}}</div>
                <div class="title">{{item.title | jobTitleFilter}}</div>
                <div class="department"><span>{{item.p_dep_title}}</span>|<span>{{item.dep_title}}</span></div>
              </div>
            </div>
            <div class="price-box">
              <div class="price"><em>¥</em>{{item.money}}<span>/次</span></div>
              <div class="price-type">医事服务费</div>
            </div>
          </div>
          <div class="card-control">
            <div class="last-time">
              <div class="type">上次就诊时间</div>
              <div class="date">{{item.pre_time | lastDateFilter}}</div>
            </div>
            <button class="check-detail">查看详情</button>
          </div>
        </div>
        <div class="status booking" v-if="item.type == 1">
          <div class="status-text">预约复诊时间：{{item.start_time | dateFilter('month')}} - {{item.end_time | timeFilter}}</div>
        </div>
        <div class="status live" v-if="item.type == 2">
          <div class="status-text">实时问诊：{{item.start_time | dateFilter('month')}} - {{item.end_time | dateFilter('month')}}</div>
        </div>
      </div>
      <div class="add-doctor"><button class="add-doctor-button" @click="toBind"><icon icon-class="add"></icon>添加医生</button></div>
    </div>
    <div class="empty-doctor" v-else-if="dataDone && doctorList.length == 0">
      <icon icon-class="empty-doctor"></icon>
      <p>还没有绑定的医生</p>
      <button class="bind-doctor" @click="toBind">绑定医生</button>
    </div>
  </div>

</template>

<style lang="less">
  .list-loading{
    padding-top: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .empty-doctor{
    padding-top: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #CCC;
    text-align: center;
    flex-direction: column;
    svg{
      font-size: 72px;
    }
    p{
      margin-top: 12px;
      font-size: 15px;
      line-height: 15px;
    }
    .bind-doctor{
      @button-base();
      @button-border();
      margin: 40px auto 0;
      width: 200px;
      height: 38px;
    }
  }
  .doctor-list{
    padding: 16px;
    min-height: 100vh;
    background: #F7F7F7;
    .doctor-item{
      margin-bottom: 12px;
      .doctor-card{
        position: relative;
        background: #FFF;
        padding: 0 16px;
        border-radius: 6px;
        box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
        z-index: 11;
        .doc-info{
          position: relative;
          padding: 12px 0 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid #EEE;
          .info{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .avatar{
              width: 56px;
              height: 56px;
              overflow: hidden;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 100%;
              }
            }
            .info-text{
              margin-left: 8px;
              margin-top: 6px;
              .name{
                font-size: 15px;
                line-height: 18px;
                color: @black;
                padding-left: 8px;
                max-width: 90%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: bold;
              }
              .title{
                margin-top: 6px;
                color: #999;
                font-size: 14px;
                font-weight: normal;
                padding-left: 8px;
              }
              .department{
                margin-top: 8px;
                height: 24px;
                font-size: 14px;
                line-height: 24px;
                color: rgba(0, 132, 138, 0.2);
                display: inline-flex;
                align-items: center;
                .xile-alpha(0.06);
                span{
                  color: @xile;
                  margin: 0 8px;
                }
              }
            }
          }
          .price-box{
            position: absolute;
            top: 24px;
            right: 0;
            .price{
              font-size: 15px;
              line-height: 15px;
              color: @black;
              em{
                font-size: 12px;
                margin-right: 2px;
              }
              span{
                font-size: 12px;
                margin-left: 4px;
              }
            }
            .price-type{
              margin-top: 4px;
              font-size: 13px;
              line-height: 13px;
              color: #999;
              text-align: right;
            }
          }
        }
        .card-control{
          height: 52px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .last-time{
            font-size: 13px;
            line-height: 13px;
            .type{
              color: #666;
            }
            .date{
              margin-top: 5px;
              color: #666;
            }
          }
          .check-detail{
            @button-base();
            @button-border();
            width: 76px;
            height: 29px;
            font-weight: normal;
            font-size: 13px;
            border-radius: 28px;
          }
        }
      }
      .status{
        position: relative;
        border-radius: 6px;
        background: @xile;
        color: #FFF;
        padding: 6px 17px 0;
        margin-top: -6px;
        z-index: 10;
        &.live{
          background: #F96B6F;
        }
        .status-text{
          font-size: 14px;
          line-height: 30px;
          font-weight: bold;
        }
      }
    }
    .add-doctor{
      width: 260px;
      margin: 28px auto 0;
      .add-doctor-button{
        @button-base();
        @button-border();
        width: 100%;
        height: 38px;
        background: transparent;
        svg{
          color: @xile;
          font-size: 12px;
          margin-right: 4px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        doctorList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.$root.post('/getDoctor', {
        pat_id: this.userInfo.user_id
      }).then(data => {
        console.log(data);
        this.dataDone = true;
        this.doctorList = data || [];
      })
    },
    methods: {
      toBind() {
        this.$router.push('/patient/code-binding');
      },
      // 去医生详情
      toDetail(item) {
        this.$router.push({name: 'PatientDoctorDetail', params: {id: item.doc_id}})
      }
    },
    filters: {
      lastDateFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MyDoctor/list.vue